import {
  DIM2CLASS
} from '../core/icon-class';

require('./sidebar.component.scss');

class SidebarController {
  constructor(
    $scope,
    $element,
    $timeout,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    $rootScope,
    PermissionService,
    RouterService,
    FiltersService,
    LayoutService,
    LocalStorageService,
    FilesTreeService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.$rootScope = $rootScope;
    this.permission = PermissionService;
    this.router = RouterService;
    this.FiltersService = FiltersService;
    this.FilesTreeService = FilesTreeService;
    this.layout = LayoutService;
    this.layout.openAll = 0;
    this.localStorage = LocalStorageService;
    this.$timeout = $timeout;
    this.isShowFootWord = true;
    this.panelWidth = 0;

    this.$scope.$on('init', (e) => this.$timeout(() => {
      this.panelWidth = this.$element[0].offsetWidth;
      const sidebar = this.$element.find('.aggregate-left')[0];
      if (sidebar)
        this.setIsShowFootWord(e, this.$element.find('.aggregate-left')[0].offsetWidth);
    }, 10));


    this.$scope.$on('splitter1Mouseup', (e, d1, d2, name) => {
      this.panelWidth = d1;
      if (d1 && this.layout.options.saveInterface.value)
        this.$timeout(() => this.localStorage.setItem(name, d1), 100);
    });

    this.$scope.$on('splitter1Changed', (e, d1, d2, name) => {
      this.panelWidth = d1;
      this.$scope.$broadcast('resize');
    });

    this.$scope.$on('splitter2Changed', (e, d1, d2, name) => {
      this.setIsShowFootWord(e, d1);
    });

    this.$scope.$on('splitter2Mouseup', (e, d1, d2, name) => {
      if (this.layout.options.saveInterface.value)
        this.$timeout(() => this.localStorage.setItem(name, d1), 100);
      this.setIsShowFootWord(e, d1);
    });
  }

  setIsShowFootWord(e, d1) {
    this.isShowFootWord = this.panelWidth > 500;
    if (e.targetScope.$$phase) return;
    this.$scope.$apply();
  }

  openAll() {
    this.FiltersService.openedFilters.all = true;
  }

  closeAll() {
    this.FiltersService.openedFilters = {
      all: false,
    };
  }

  toggleEditCatalog() {
    this.layout.editCatalog = !this.layout.editCatalog;
  }

  get isEditCatalog() {
    return (!!this.layout.editCatalog && this.panel === 'catalog') || ['files', 'usercard'].includes(this.panel);
  }

  get model() {
    return this.CurrentModelService.model;
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  get filters() {
    return this.FiltersService.filters;
  }

  viewReport() {
    this.router.panel = 'catalog';
    this.$rootScope.$broadcast('resize');
  }

  viewFilter() {
    this.router.panel = 'constructor';
    this.$rootScope.$broadcast('resize');
  }

  viewFiles() {
    this.router.panel = 'files';
    this.$rootScope.$broadcast('resize');
  }

  viewUserCard() {
    this.router.panel = 'usercard';
    this.$rootScope.$broadcast('resize');
  }

  get isShowFiles(){
    return this.FilesTreeService.data && this.FilesTreeService.data.length;
  }
}

export function SidebarComponent() {
  return {
    restrict: 'E',
    template: require('./sidebar.component.html'),
    scope: true,
    controller: SidebarController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/layout/sidebar.component.js